import * as React from "react";

const ChevronDownIcon = (props) => (
  <svg
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="m7.293 0-3.16 3.21L.976 0 0 .99l4.134 4.201 4.133-4.2L7.293 0Z"
      fill="currentColor"
    />
  </svg>
);

export default ChevronDownIcon;
